import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

// Buffalo Bucks (vendor portrait build, real wallet via /api/buffalo-bucks).
export default function BbRoute() {
    const navigate = useNavigate();
    const { refreshUser } = useAuth();
    const exit = () => { refreshUser?.(); navigate('/casino/slots'); };
    return (
        <>
            <iframe data-testid="bb-game-frame" src="/games/buffalo-bucks/index.html?mode=live&v=5" title="Buffalo Bucks" allow="autoplay; fullscreen" allowFullScreen
                style={{ position: 'fixed', inset: 0, width: '100%', height: '100dvh', border: 0, background: '#0c070b', zIndex: 60 }} />
            <button type="button" onClick={exit} data-testid="bb-exit-btn" aria-label="Back to slots"
                className="fixed bottom-1 left-2 z-[61] flex items-center gap-1 rounded-full bg-black/60 px-3 py-1.5 text-xs font-bold text-[#ffe4a3] border border-[#e3ae54]/40 backdrop-blur hover:bg-black/80 transition-colors">
                <ArrowLeft className="w-3.5 h-3.5" /> Back
            </button>
        </>
    );
}
